import React, { useState } from 'react'
import { Modal } from 'react-responsive-modal'
import { AchievementItemType } from '../../containers/ProfileAchievementsPage/types'
import moment from 'moment'
import 'moment/locale/ru'

// Componenets
import ModalDownloadAchievement from '../ModalDownloadAchievement'

// Styles
import './styles.scss'

// Icons
import IconClose from '../ModalFiles/images/iconClose'
import IconDownload from './images/iconDownload'
import IconVK from './images/iconVK'

moment.locale('ru')

export default ({
  onClose,
  achievement,
}: {
  onClose: () => void
  achievement: AchievementItemType | null
}) => {
  const [isOpenDownload, setIsOpenDownload] = useState<boolean>(false)
  const [modalType, setModalType] = useState<'download' | 'share'>('download')

  const modalStyles = {
    root: {
      zIndex: 99999,
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.4)',
    },
    modal: {
      width: 565,
      borderRadius: 50,
      padding: 0,
      margin: '2em',
      boxShadow: 'unset',
      overflow: 'unset',
      outline: 0,
    },
  }

  if (!achievement) return null

  return (
    <>
      <Modal
        open={!isOpenDownload}
        showCloseIcon={false}
        onClose={onClose}
        styles={modalStyles}
        center={true}
      >
        <div className={'modal-achievement'}>
          <button className={'modal__close'} onClick={onClose}>
            <IconClose />
          </button>
          <span style={{ marginBottom: 53 }} className={'modal__title'}>
            {achievement.caption}
          </span>
          <div className={'modal-achievement__outer'}>
            <div
              className={
                achievement.user_achievement
                  ? 'modal-achievement__icon'
                  : 'modal-achievement__icon grayscale'
              }
            >
              {achievement.image_media ? (
                <img src={achievement.image_media.url} />
              ) : null}
            </div>
            <div className={'modal-achievement__desc'}>
              {achievement.user_achievement
                ? achievement.description
                : achievement.requirements}
            </div>
            {achievement.user_achievement ? (
              <div className={'modal-achievement__nav'}>
                <div
                  className={'modal-achievement__nav-item'}
                  style={{ flex: 1, maxWidth: 'unset' }}
                >
                  <div
                    className={'button'}
                    onClick={() => {
                      setModalType('download')
                      setIsOpenDownload(true)
                    }}
                  >
                    <IconDownload />
                    <div className={'button__text'}>Скачать достижение</div>
                  </div>
                </div>
                <div
                  className={'modal-achievement__nav-item'}
                  onClick={() => {
                    setModalType('share')
                    setIsOpenDownload(true)
                  }}
                >
                  <div className={'button'}>
                    <IconVK />
                    <div className={'button__text'}>Поделиться достижением</div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </Modal>
      <ModalDownloadAchievement
        achievement={achievement}
        modal={isOpenDownload}
        type={modalType}
        onClose={() => setIsOpenDownload(false)}
      />
    </>
  )
}
